import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import PersistentPlayer from "@/components/PersistentPlayer";
import BackgroundVideo from "@/components/BackgroundVideo";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ArtistDetail from "@/pages/ArtistDetail";
import OnDemand from "@/pages/OnDemand";

function App() {
  return (
    <div className="App">
      <BackgroundVideo />
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/artist/:slug" element={<ArtistDetail />} />
              <Route path="/on-demand" element={<OnDemand />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              {/* Legacy Warriors Culture Hub routes → new home */}
              <Route path="/warriors" element={<Navigate to="/" replace />} />
              <Route path="/culture" element={<Navigate to="/" replace />} />
              <Route path="/warriors/*" element={<Navigate to="/" replace />} />
              <Route path="/culture/*" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <PersistentPlayer />
            <Toaster theme="dark" position="top-center" />
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
